import React from 'react';
import CollectionsCards from '../components/collections/CollectionsCards';

const Collections = () => {
  document.title = "Collections - HOLIVANA Ayurvedic Wellness"

  return (
    <CollectionsCards />
  );
};

export default Collections;
